import {
  App,
  Button, Card, Flex, Form, Input, Rate, Space, Typography
} from "antd";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { APP_PATH } from "../../constants/routes";
import { UPDATE_FEEDBACK } from "./feedback.qql";

const { Title, Text } = Typography;

const FeedbackForm = ({ feedbackId }: { feedbackId: number | undefined }) => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const navigate = useNavigate();

  const [updateFeedback, { loading: updateFeedbackLoading }] = useMutation(UPDATE_FEEDBACK, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      message.success(t("feedback.successMessage"));
      navigate(APP_PATH);
    },
    onError: ({ graphQLErrors }) => {
      message.error(graphQLErrors[0].message);
    }
  });

  return (
    <Card>
      <Space direction="vertical" style={{ marginBottom: 24 }}>
        <Title level={3} style={{ marginBottom: 0 }}>
          {t("feedback.title")}
        </Title>
        <Text>
          {t("feedback.subtitle")}
        </Text>
      </Space>
      <Form
        layout="vertical"
        onFinish={(values) => {
          updateFeedback({
            variables: {
              id: feedbackId,
              ...values
            }
          });
        }}
      >
        <Flex vertical gap="8px">
          <Flex align="center" justify="space-between" gap="16px">
            <Text strong>{t("feedback.form.connection")}</Text>
            <Form.Item name="connection" style={{ marginBottom: 0 }}>
              <Rate />
            </Form.Item>
          </Flex>
          <Flex align="center" justify="space-between" gap="16px">
            <Text strong>{t("feedback.form.professionist")}</Text>
            <Form.Item name="professionist" style={{ marginBottom: 0 }}>
              <Rate />
            </Form.Item>
          </Flex>
          <Flex align="center" justify="space-between" gap="16px">
            <Text strong>{t("feedback.form.audio_video")}</Text>
            <Form.Item name="audio_video" style={{ marginBottom: 0 }}>
              <Rate />
            </Form.Item>
          </Flex>
          <Form.Item name="comment" label={t("feedback.form.comment")} style={{ marginBottom: 0 }}>
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item style={{ margin: "12px 0 0" }}>
            <Flex gap="8px" justify="end">
              <Button
                loading={updateFeedbackLoading}
                disabled={updateFeedbackLoading}
                onClick={() => navigate(APP_PATH)}
              >
                {t("feedback.cancelButton")}
              </Button>
              <Button
                loading={updateFeedbackLoading}
                disabled={updateFeedbackLoading}
                type="primary"
                htmlType="submit"
              >
                {t("feedback.okButton")}
              </Button>
            </Flex>
          </Form.Item>
        </Flex>
      </Form>
    </Card>
  );
};

export default FeedbackForm;
